<template>
  <div>
    <back-header :head-title="title"></back-header>
    <div class="nick_wrapper">
      <div class="input_area">
        <input type="text" v-model="nickName" />
      </div>
      <div class="submit" @click="submit">确认</div>
    </div>
  </div>
</template>

<script>
import backHeader from "components/header/backHeader";
import { getStore,setStore} from "assets/commonjs/storage";
import { toast } from "assets/commonjs/toast";
export default {
  data() {
    return {
      title: "修改昵称",
      nickName: "",
      userId: "",
      companyId: 1
    };
  },
  mounted() {
    let userInfo = JSON.parse(getStore("userInfoAll"));
    if (userInfo != "" && userInfo != undefined && userInfo != null) {
      // this.userId = userInfo.id;
      this.userId = userInfo.userId;
    } else {
      this.$router.push("/login");
    }
    this.getNickName();
  },
  methods: {
    getNickName(label) {
      let data = {
        companyId: this.companyId,
        userId: this.userId
      };
      this.$api.strageList.getNickName(data).then(res => {
        if (res.data && res.data.code == 0) {
          this.nickName = res.data.result.displayName;
          let userInfo = JSON.parse(getStore("userInfoAll"));
          userInfo.displayName = this.nickName
          setStore('userInfoAll',JSON.stringify(userInfo))
          if(label == "change"){
            this.$router.go(-1);
          }
        
        }else{
            toast(res.data.message)
        }
      });
    },
    submit() {
      let pattern = /\s/;
      if (pattern.test(this.nickName)) {
        toast("昵称不能含有空格");
        return false;
      } else if (this.nickName == "") {
        toast("昵称不能含为空");
        return false;
      } else if (this.nickName.length > 10) {
        toast("昵称长度不能超过10位");
        return false;
      } else if ( getStore("userInfoAll") == null || getStore("userInfoAll") == "" || getStore("userInfoAll") == undefined) {
          if (
            getStore("noneheader") == null ||
            getStore("noneheader") == "" ||
            getStore("noneheader") == undefined
          ){
              this.$router.push("/login");
          }else{
            // app拦截登录
            window.location.href = "intercept_login";
          }
   
      } else {
        let data = {
          userId: this.userId,
          companyId: this.companyId,
          displayName: this.nickName
        };
        this.$api.strageList.updataNickName(data).then(res => {
          if (res.data && res.data.code == 0) {
            this.getNickName("change");
             toast("修改成功");
              
          }else{
               toast(res.data.message)
          }
        });
      }
    }
  },
  components: {
    backHeader
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.nick_wrapper {
  background: #f0f1f5;
  position: fixed;
  width: 100%;
  height: 100%;
  top: .9rem;
  padding-bottom: 0.5rem;
  font-size: 0;
  input {
    @include sc(0.28rem, #333);
    line-height: 0.9rem;
    width: 100%;
    padding-left: 0.3rem;
  }
  .submit {
    @include wh(6.9rem, 0.9rem);
    text-align: center;
    line-height: 0.9rem;
    @include sc(0.32rem, #fff);
    background: #0a95ff;
    border-radius: 0.06rem;
    margin: 0.6rem auto 0;
  }
}
</style>